<template>
    <div class="loading-mask">
        <div class="loading-content">
            <img src="@/assets/img/main.gif" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
}
</script>
<style scoped lang='scss'>
.loading-mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 998;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading-content {
    position: relative;
    z-index: 999;
    width: 300px;

    >img {
        width: 100%;
    }
}
</style>